<template>
  <AppointTime v-if="status === 'wait'" />
  <div class="live-tab flex">
    <div
      :class="['live-tab-item', active === 'details' ? 'active' : '']"
      @click="() => (active = 'details')"
    >
      Details
    </div>
    <div
      :class="['live-tab-item', active === 'introduction' ? 'active' : '']"
      @click="() => (active = 'introduction')"
    >
      Description
    </div>
  </div>
  <div
    v-show="active === 'details'"
    class="live-tab-content im droidSerif"
    :style="{ height: `${detailsContentStyle}px` }"
  >
    <div
      class="content"
      ref="messageContainer"
      :style="{ height: `${detailsContentStyle - 60}px` }"
    >
      <template v-if="store.global.chatData?.length > 0">
        <div class="chat-item" v-for="item in store.global.chatData" :key="item.id">
          <div class="chat-item-top">
            <div class="flex" style="gap: 8px">
              <n-avatar round :size="24" :src="item.avatar" />
              <span class="username droidSerif">{{ item.name }}</span>
            </div>
            <span class="time droidSerif">{{ timeFromNow(item.receivedTime) }}</span>
          </div>
          <div class="chat-item-bottom">
            <template v-if="item.pictureUrls && item.pictureUrls?.length > 0">
              <div class="chat-item-pic" v-for="el in item.pictureUrls" :key="el">
                <n-image width="312" height="234" object-fit="cover" :src="el" />
              </div>
            </template>
            <div class="droidSerif chat-item-content">
              {{ item.content }}
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="no-content" :style="{ paddingTop: status === 'wait' ? '54px' : undefined }">
          <img src="/src/assets/live/no-content.svg" alt="no-content.svg" />
          <div class="droidSerif text-hex-7d7f8b text-center">No content</div>
        </div>
      </template>
    </div>
    <div class="bottom" @click="handleScrollD">
      <img v-if="messageScrollNum > 0" src="/src/assets/extraIcon/iconTop.png" alt="iconTop.png" />
      <img v-else src="/src/assets/extraIcon/iconDown.png" alt="iconDown.png" />
    </div>
  </div>
  <div
    v-show="active === 'introduction'"
    class="live-tab-content droidSerif introduction"
    :style="{ height: `${detailsContentStyle}px` }"
  >
    <div
      v-if="!!introductionText"
      class="content"
      ref="detailsContainer"
      :style="{ height: `${detailsContentStyle - 60}px` }"
      v-html="introductionText"
    />
    <template v-else>
      <div class="content" :style="{ height: `${detailsContentStyle - 60}px` }">
        <div class="no-content" :style="{ paddingTop: status === 'wait' ? '54px' : undefined }">
          <img src="/src/assets/live/no-content.svg" alt="no-content.svg" />
          <div class="droidSerif text-hex-7d7f8b text-center">No content</div>
        </div>
      </div>
    </template>
    <div class="bottom" @click="handleScrollD">
      <img v-if="detailsScrollNum > 0" src="/src/assets/extraIcon/iconTop.png" alt="iconTop.png" />
      <img v-else src="/src/assets/extraIcon/iconDown.png" alt="iconDown.png" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useStore } from '@gx-vuex'
import scrollTo from '@/hooks/system/scroll/scrollTo'
import AppointTime from '../appointTime/index.vue'
import { timeFromNow } from '@/utils/util'

const store = useStore()

const contentId = document.querySelector('body').getAttribute('data-id')
const tplId = ref(document.querySelector('body').getAttribute('data-tplId') as any)
const landscape = ref(document.querySelector('body').getAttribute('data-landscape') as any)

const introductionText = ref(document.querySelector('.hidden-introduction').innerHTML)

const active = ref(landscape.value == '2' ? 'introduction' : 'details')

const messageContainer = ref()
const detailsContainer = ref()

const messageScrollNum = ref(0)
const detailsScrollNum = ref(0)
const showMore = ref(false)

const detailsContentStyle = computed(() => {
  let height = 673
  if (tplId.value === '6' && store.global.liveStatus === 'running') {
    height = 795
  }
  if (store.global.liveStatus === 'wait') {
    height = height - 142
  }

  return height - 63
})

watch(
  () => active.value,
  (val) => {
    if (val === 'introduction') {
      store.point.nameClick('live_introduce')
    } else {
      store.point.nameClick('article_click')
    }
  }
)

// watch(() => store.settings.liveId, (val) => {
//   if (val != contentId) {
//     handleScrollD()
//
//     const landscapes =  isJSONStr(store.settings.liveInfo?.streamWH) ? JSON.parse(store.settings.liveInfo?.streamWH) : {}
//     if (landscapes) {
//       landscape.value = landscapes.landscape
//     }
//
//     status.value = store.settings.liveInfo?.status
//
//     if (landscape.value === '2') startIm()
//   }
// })

watch(
  () => store.global.scrollNum,
  () => {
    scrollBottom()
  }
)

onMounted(async () => {
  nextTick(() => {
    messageContainer.value && messageContainer.value.addEventListener('scroll', messageScroll)
    detailsContainer.value && detailsContainer.value.addEventListener('scroll', detailsScroll)
  })
})

const messageScroll = () => {
  messageScrollNum.value = messageContainer.value.scrollTop

  const scrollTop = messageContainer.value.scrollTop
  const scrollHeight = messageContainer.value.scrollHeight
  const clientHeight = messageContainer.value.clientHeight
  showMore.value = !(scrollTop + clientHeight + 10 >= scrollHeight)
}

const detailsScroll = () => {
  detailsScrollNum.value = detailsContainer.value.scrollTop
}

const handleScrollD = () => {
  if (active.value === 'details') {
    if (messageScrollNum.value > 0) scrollTop()
    else scrollBottom()
  } else {
    if (detailsScrollNum.value > 0) scrollTop()
    else scrollBottom()
  }
}

const scrollTop = () => {
  nextTick(() => {
    scrollTo(0, {
      getContainer: () =>
        active.value === 'details' ? messageContainer.value : detailsContainer.value,
      duration: 250
    })
  })
}

const scrollBottom = () => {
  nextTick(() => {
    scrollTo(
      active.value === 'details'
        ? messageContainer.value.scrollHeight
        : detailsContainer.value.scrollHeight,
      {
        getContainer: () =>
          active.value === 'details' ? messageContainer.value : detailsContainer.value,
        duration: 250
      }
    )
  })
}
</script>

<style lang="less" scoped>
@import './style';
</style>
